/* RESOURCES */
export const SEARCH_RESOURCES = "SEARCH_RESOURCES"
export const SEARCH_RESOURCES_SUCCESS = "SEARCH_RESOURCES_SUCCESS"
export const SEARCH_RESOURCES_FAIL = "SEARCH_RESOURCES_FAIL"
